import { render, staticRenderFns } from "./AccountingDefault.vue?vue&type=template&id=53e4b464"
import script from "./AccountingDefault.vue?vue&type=script&lang=ts"
export * from "./AccountingDefault.vue?vue&type=script&lang=ts"
import style0 from "./AccountingDefault.vue?vue&type=style&index=0&id=53e4b464&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53e4b464')) {
      api.createRecord('53e4b464', component.options)
    } else {
      api.reload('53e4b464', component.options)
    }
    module.hot.accept("./AccountingDefault.vue?vue&type=template&id=53e4b464", function () {
      api.rerender('53e4b464', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/AccountingDefault.vue"
export default component.exports